import { render, staticRenderFns } from "./AuditTable.vue?vue&type=template&id=4839b004&scoped=true&"
import script from "./AuditTable.vue?vue&type=script&lang=js&"
export * from "./AuditTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditTable.vue?vue&type=style&index=0&id=4839b004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4839b004",
  null
  
)

export default component.exports